import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Footer from "../../components/Footer";
import NetworkSubmit from "../../components/NetworkSubmit";
import {API_ROUTE_LOGIN, buttonType, netState, RECAPTCHA_SITE_KEY} from "../../constant";
import Container from "@material-ui/core/Container";
import {ValidateEmail} from "../../utils/validate";
import api from "../../api";
import {useSignIn} from "react-auth-jwt";
import {useHistory} from "react-router-dom"


const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
    },
    image: {
        backgroundImage: 'url(https://source.unsplash.com/random)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    subheader: {
        marginBottom: theme.spacing(8)
    },
}));

const AllLogin = () => {
    const signIn = useSignIn();
    const history = useHistory()
    const classes = useStyles();
    const [formState, setFormState] = React.useState({email:'', password: ''})
    const [errors, setErrors] = React.useState({
        email: [false, "Enter registered Email-Id"],
        password: [false, "Password should be minimum 8"],
    })
    const [networkState, setNetworkState] = React.useState([netState.IDLE, '']);

    const handleFormDataChange = (name) => (e) => {
        e.persist()
        setFormState(prevState => ({...prevState, [name]: e.target.value}))
    }

    const checkEmailId = () => {
        if (ValidateEmail(formState.email)) {
            setErrors(prevState => ({...prevState, email: [false, "Enter registered Email-Id"]}))
            return true
        } else {
            setErrors(prevState => ({...prevState, email: [true, "Invalid Email-ID"]}))
            return false
        }
    }

    const checkPassword = () => {
        if (formState.password.length > 7) {
            setErrors(prevState => ({...prevState, password: [false, "Password should be minimum 8"]}))
            return true
        } else {
            setErrors(prevState => ({...prevState, password: [true, "Invalid Password"]}))
            return false
        }
    }

    const validate = () => {
        const e = checkEmailId()
        const p = checkPassword()

        return e && p
    }

    const handleSubmit = () => {
        if(validate()){
            setNetworkState([netState.BUSY, ''])
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'login'}).then((token) => {
                    api.post(API_ROUTE_LOGIN, {
                        ...formState,
                        recaptcha_token: token
                    }).then((res) => {
                        if (res.data.status) {
                            signIn(res.data.jwt, res.data.expiresAt || 120, res.data.user) ?
                                history.push(`/${res.data.role}/dashboard`) :
                                setNetworkState([netState.ERROR, res.data.error])
                        } else {
                            setNetworkState([netState.ERROR, `Internal error occurred (Sign-In failed)`])
                        }
                    }).catch((e) => {
                        console.error(e)
                        setNetworkState([netState.ERROR, `Internal error occurred 
                        (${e.response.status} - ${e.response.data.error})`])
                    })
                }).catch((e)=>{
                    console.error(e)
                    setNetworkState([netState.ERROR, "Recaptcha failed - Please try again"])
                })
            })
        }
    }

    return (
        <Grid container component="main" className={classes.root}>
            <Grid item xs={false} sm={4} md={8} className={classes.image} />
            <Grid item xs={12} sm={8} md={4} component={Paper} elevation={6} square>
                <Container>
                    <div className={classes.paper}>
                        <Typography variant={"h4"} className={classes.subheader}>
                            KNCS Portal
                        </Typography>
                        <div className={classes.bar}/>
                        <Avatar className={classes.avatar}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Sign in
                        </Typography>
                        <form className={classes.form} noValidate>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                error={errors.email[0]}
                                helperText={errors.email[1]}
                                value={formState.email}
                                onChange={handleFormDataChange('email')}
                                autoFocus
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                error={errors.password[0]}
                                helperText={errors.password[1]}
                                value={formState.password}
                                onChange={handleFormDataChange('password')}
                                autoComplete="current-password"
                            />
                            <NetworkSubmit
                                networkState={networkState[0]}
                                buttonStyle={buttonType.SUBMIT}
                                handleSubmit={handleSubmit}
                            />
                        </form>
                        <Typography variant={"subtitle2"} align={"center"} color={"error"}>
                            {networkState[0] === netState.ERROR ? networkState[1] : ""}
                        </Typography>
                    </div>
                </Container>
                <Box mt={5}>
                    <Footer />
                </Box>
            </Grid>
        </Grid>
    );
}

export default AllLogin